import { ProjectType, UnitType } from "../../../interfaces/project"
import { getDateYMD } from "../../../utils/Functions"
import useUser from '../../../hooks/user/useUser'
import { EstimatorData } from "../Estimator"

export const FeaturesTop = ({ project, unit, inmo_logo_encoded, isSecondPage = false, clientData }: 
    { project: ProjectType, unit: UnitType, inmo_logo_encoded: string, isSecondPage?: boolean, clientData?: EstimatorData }) => {
    
    const {userState} = useUser()

    return (
        <>
            <div className="img-inmobiliaria d-flex justify-content-end" >
                
            </div>
            <div className="d-flex position-relative" style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                <h1 className="fw-bold fs-5 mt-3">COTIZACIÓN</h1>
                {inmo_logo_encoded && inmo_logo_encoded != '' && 
                    <img src={inmo_logo_encoded} alt="" width={80} height={80}
                        style={{ objectFit: 'contain', position: 'absolute', top: 0, right: 0 }}
                    />}
            </div>

            <div className="mt-4">
                <table>
                    <tbody>
                        {!isSecondPage ? (
                            // Primera página: datos del cliente
                            <>
                                {clientData?.client_name && (
                                    <tr>
                                        <td>Nombre</td>
                                        <td>: {clientData.client_name}</td>
                                    </tr>
                                )}
                                {clientData?.client_rut && (
                                    <tr>
                                        <td>RUT</td>
                                        <td>: {clientData.client_rut}</td>
                                    </tr>
                                )}
                                {clientData?.client_phone && (
                                    <tr>
                                        <td>Teléfono</td>
                                        <td>: {clientData.client_phone}</td>
                                    </tr>
                                )}
                            </>
                        ) : (
                            // Segunda página: datos del proyecto
                            <>
                                <tr>
                                    <td>Proyecto</td>
                                    <td>: {project.title}</td>
                                </tr>
                                <tr>
                                    <td>Dirección</td>
                                    <td>: {project.address}</td>
                                </tr>
                                <tr>
                                    <td>Comuna</td>
                                    <td>: {project.zone?.name}</td>
                                </tr>
                                <tr>
                                    <td>Unidad</td>
                                    <td>: {unit.number}</td>
                                </tr>
                                <tr>
                                    <td>Fecha</td>
                                    <td>: {getDateYMD(new Date(), '-')}</td>
                                </tr>
                                <tr>
                                    <td>Agente Broker</td>
                                    <td>: {userState.real_estate}</td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    )
}